import Head from "next/head";
import { Box, Typography } from "@bca/ui-library";

import Layout from "../Layout";

export const SalesPageTitle: React.FunctionComponent = () => {
  return (
    <Box
      maxWidth={["calc(100% - 48px)", "calc(100% - 48px)", "976px", "976px"]}
      margin="0 auto"
    >
      <Typography variant="h3" color="primary-white" paddingY="40px" margin="0">
        Sales Calendar
      </Typography>
    </Box>
  );
};

interface SalesPageLayoutProps {
  user?: { firstName: string; lastName: string };
  idToken?: string;
  isToUseAuthZero: boolean;
  isAuthenticated: boolean;
  children: any;
  logoutUrl?: string;
}

export const SalesPageLayout: React.FunctionComponent<SalesPageLayoutProps> = ({
  user,
  idToken,
  isToUseAuthZero,
  isAuthenticated,
  children,
  logoutUrl,
}: any) => {
  return (
    <Layout
      user={user ?? undefined}
      idToken={idToken}
      isToUseAuthZero={isToUseAuthZero}
      isAuthenticated={isAuthenticated}
      logoutUrl={logoutUrl}
    >
      <Head>
        <title>Sales</title>
      </Head>
      <svg
        style={{
          height: 0,
          width: 0,
          position: "absolute",
          zIndex: -999,
          visibility: "hidden",
        }}
      >
        <defs>
          <linearGradient id="arrowgrad">
            <stop offset="0%" style={{ stopColor: "#21c9f3" }}></stop>
            <stop offset="100%" style={{ stopColor: "#2196f3" }}></stop>
          </linearGradient>
        </defs>
      </svg>
      {children}
    </Layout>
  );
};
